import { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';

/**
 * ModalPortal
 * Renders children directly into document.body so they escape the
 * .v2-shell's `overflow: hidden` / `position: fixed` stacking context.
 *
 * Usage:
 *   <ModalPortal>
 *     <div className="fixed inset-0 ...">...</div>
 *   </ModalPortal>
 */
const ModalPortal = ({ children }) => {
  const elRef = useRef(null);

  if (!elRef.current) {
    elRef.current = document.createElement('div');
    elRef.current.setAttribute('data-modal-portal', 'true');
  }

  useEffect(() => {
    const el = elRef.current;
    document.body.appendChild(el);
    return () => {
      document.body.removeChild(el);
    };
  }, []);

  return createPortal(children, elRef.current);
};

export default ModalPortal;
